import { DynamicIconWrapper, Icons } from '@components/common';

import { TNameTitleColor } from '@interfaces/common/common';

import colors from '@constants/colors';
import { EChangeMonitorStatuses } from '../constants';

import styles from './ChangeMonitoringStatusCell.module.scss';

interface IChangeMonitoringStatusCellProps {
	status?: TNameTitleColor;
	errorNameList?: string[];
	tooltipLabel?: string;
	isError?: boolean;
	openErrorMessageModal?: () => void;
}

const ChangeMonitoringStatusCell = ({
	status,
	tooltipLabel = 'View Error',
	isError = false,
	errorNameList = [EChangeMonitorStatuses.CANDIDATE_ERROR, EChangeMonitorStatuses.RUNNING_ERROR],
	openErrorMessageModal,
}: IChangeMonitoringStatusCellProps) => {
	if (!status) {
		return null;
	}

	const { name, title, color } = status || {};

	const isErrorVisible = errorNameList.includes(name) || isError;

	return (
		<div className={styles.wrapper}>
			{Icons.uncheck({ color: color || 'red' })}
			<span className={styles.title}>{title}</span>
			{isErrorVisible && (
				<DynamicIconWrapper
					icon={Icons.errorPlateIcon}
					iconStyle={{ color: colors.red50, fill: colors.white }}
					onClick={openErrorMessageModal}
					tooltipLabel={tooltipLabel}
					tooltipPosition='top'
					withHover
					wrapperStyle={{
						backgroundColor: 'transparent',
					}}
				/>)
			}
		</div>
	);
};

export default ChangeMonitoringStatusCell;
